import formatNumber from 'src/utils/formatNumber';

type NullableMetric = number | null | undefined;

export const hasMeasuredValue = (value: NullableMetric): value is number =>
    typeof value === 'number' && Number.isFinite(value);

export const formatMeasuredValue = (value: NullableMetric, suffix = '') =>
    hasMeasuredValue(value) ? `${formatNumber(value)}${suffix}` : 'Нет данных';

export const formatMeasuredRange = (low: NullableMetric, high: NullableMetric, suffix = '') =>
    hasMeasuredValue(low) && hasMeasuredValue(high)
        ? `${formatNumber(low)}–${formatNumber(high)}${suffix}`
        : 'Нет данных';

export const measuredValueHint = (label: string, value: NullableMetric, suffix = '') =>
    hasMeasuredValue(value) ? `${label}: ${formatNumber(value)}${suffix}` : 'Не измерено';
